import { useMemo } from 'react';
import { omitBy, isNil } from 'lodash';

import { ensureDefined } from '@e-socna/utils';
import { EMPTY_ARRAY, EMPTY_STRING } from '@e-socna/empty';
import { CodingStrategyEnum } from '@e-socna/data-layer';

import { useIdFactory } from '../../../hooks/useIdFactory.hook';
import { useReferencesContext } from '../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import type { MaterialForm_Material } from '../fragments/material.fragment';

export const useInitialValuesFactory = (
  pInitialValues?: MaterialForm_Material | null,
) => {
  const { generateId } = useIdFactory();

  const referencesContext = useReferencesContext();

  const { defaultGenericStatus } = ensureDefined({
    defaultGenericStatus: referencesContext.defaultGenericStatus,
  });

  const { codingStrategiesCodeMap } = referencesContext;

  const initialValues: MaterialForm_Material = useMemo(
    () => ({
      __typename: 'Material' as const,
      _id: generateId(),
      code: EMPTY_STRING,
      label: EMPTY_STRING,
      title: EMPTY_STRING,
      content: EMPTY_STRING,
      statusId: defaultGenericStatus._id,
      costUsages: EMPTY_ARRAY,
      ...omitBy(pInitialValues, isNil),
      codingConfig: {
        __typename: CodingStrategyEnum.CodingConfigManual as const,
        _id: generateId(),
        kind: CodingStrategyEnum.CodingConfigManual,
        strategyId: codingStrategiesCodeMap.CodingConfigManual._id,
        code: EMPTY_STRING,
        ...omitBy(pInitialValues?.codingConfig, isNil),
      },
    }),
    [
      pInitialValues,
      defaultGenericStatus,
      generateId,
      codingStrategiesCodeMap.CodingConfigManual._id,
    ],
  );

  return { initialValues };
};
